import React from "react";
import PropTypes from "prop-types";
import {
  Wrapper,
  Modal,
  Inner,
  Spinner,
} from "./styles/mobile-full-screen-loading-styles";
import spinner from "./img/loading.gif";
import whiteSpinner from "./img/spinner-white.gif";

const MobileFullScreenLoading = ({ color }) => (
  <Wrapper color={color && color}>
    <Modal>
      <Inner>
        {color && color === "white" && (
          <Spinner src={spinner} alt="Loading spinner" />
        )}
        {color && color === "purple" && (
          <Spinner src={whiteSpinner} alt="Loading spinner" />
        )}
      </Inner>
    </Modal>
  </Wrapper>
);

MobileFullScreenLoading.propTypes = {
  color: PropTypes.string,
};

MobileFullScreenLoading.defaultProps = {
  color: PropTypes.isNull,
};

export default MobileFullScreenLoading;
